export const optionsToLabelValuePairs = (...labels: string[]) => {
  return labels.map((l) => ({ label: l, value: l }));
};
